import React from 'react';
import PropTypes from 'prop-types';
import Step from './Step';
import useIsMobile from '../Utils/customHooks/useIsMobile';
import styles from '@dtsl/css-stepper/dist/index.module.css';
function Stepper(props) {
  const {
    activeStep,
    steps,
    className
  } = props;
  const {
    isMobile
  } = useIsMobile(640);
  const isActiveStepWithinRange = () => {
    return activeStep >= 0 && activeStep < steps.length;
  };
  const isStepperIncomplete = () => {
    return steps.some(step => !(step !== null && step !== void 0 && step.completed));
  };
  return /*#__PURE__*/React.createElement("nav", {
    className: `${styles['sib-stepper']} ${className ? className : ''}`,
    "aria-label": "Stepper Navigation"
  }, isMobile && isActiveStepWithinRange() && isStepperIncomplete() ? /*#__PURE__*/React.createElement("ol", {
    className: styles['sib-stepper__list']
  }, /*#__PURE__*/React.createElement(Step, {
    activeStep: activeStep,
    stepData: {
      ...steps[activeStep],
      stepIndex: activeStep
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: styles['sib-stepper__count'],
    type: "button"
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['sib-stepper__label']
  }, activeStep + 1, "/", steps.length))) : /*#__PURE__*/React.createElement("ol", {
    className: styles['sib-stepper__list']
  }, steps.map((step, index) => {
    return /*#__PURE__*/React.createElement(Step, {
      key: `${index}${new Date().getTime()}`,
      stepData: {
        ...step,
        stepIndex: index
      },
      activeStep: activeStep
    });
  })));
}
Stepper.defaultProps = {
  activeStep: 0,
  steps: [],
  className: ''
};
Stepper.propTypes = {
  activeStep: PropTypes.number,
  // index of the active step object in steps array
  steps: PropTypes.array,
  // list of step data objects
  className: PropTypes.string
};
export default Stepper;